export const ApprovalProcessStatusPolicy = ({
    STATUS_NEW: "NEW",
    // STATUS_PROPOSED: "PROPOSED",
    STATUS_FINALIZED: "FINALIZED",
    STATUS_REJECTED: "REJECTED",
})